import { render, staticRenderFns } from "./Assignmodal.vue?vue&type=template&id=4242c761&"
import script from "./Assignmodal.vue?vue&type=script&lang=js&"
export * from "./Assignmodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports